import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import InvoiceMetrics from '../InvoiceMetrics';
import InvoiceTasks from '../InvoiceTasks';

import { startAddInvoice } from '../../../store/actions/invoices';
import { startEditAdmin } from '../../../store/actions/admin';
import { makeGetCosts } from '../../../store/selectors';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: '10px',
    flexBasis: '500px',
    maxWidth: '500px',
  },
  content: {
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingLeft: '10px',
    paddingRight: '0px',
    paddingTop: '0px',
    paddingBottom: '5px',
  },
  paddingRight: {
    paddingRight: '10px',
  },
  button: {
    margin: theme.spacing.unit,
  },
  labelField: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
});


const ProjectSchedule = (props) => {
  const {classes, invoice, schedule, project, startAddInvoice, startEditAdmin} = props;
  const scheduleDate = schedule.scheduleDate;
  const paid = invoice === undefined ? false : invoice.isPaid;

  return(
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="title">
          Invoice
        </Typography>
        {invoice &&
          <Button
            color="primary"
            onClick={() => startEditAdmin({invoice: invoice})}>
            View
          </Button>
        }
        {!invoice &&
          <Button
            color="primary"
            onClick={() => (
              startAddInvoice({
                projectId: project.id,
                invoiceDate: scheduleDate,
                createdDate: new Date(),
                scheduleDate: scheduleDate,
                intervalId: schedule.intervalId
              })
            )}>
            Create
          </Button>
        }
      </div>
      <Divider />
      <div className={classes.content}>
        {!paid && <InvoiceTasks invoice={invoice} schedule={schedule} project={project} />}
        {paid && <InvoiceMetrics invoice={invoice} project={project} />}
      </div>

    </div>
  );
};


//Creates own private getCosts selector so that memoization is preserved
const makeMapStateToProps = () => {
  const getCosts = makeGetCosts();
  const mapStateToProps = (state, props) => {
    return {
      costs: getCosts(state, props)
    }
  };

  return mapStateToProps;
}

const mapDispatchToProps = (dispatch) => ({
  startAddInvoice: (invoice) => dispatch(startAddInvoice(invoice)),
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice))
});

export default compose(
  withStyles(styles),
  connect(makeMapStateToProps, mapDispatchToProps)
)(ProjectSchedule);



// WEBPACK FOOTER //
// ./src/components/admin/Project/ProjectSchedule.jsx